var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "flex-direction": "column" } },
    [
      _c(
        "div",
        {
          staticStyle: { display: "flex", "justify-content": "space-between" }
        },
        [
          _c("cargo-input", {
            staticStyle: {
              width: "115px",
              "margin-right": "5px",
              "flex-grow": "1"
            },
            attrs: {
              placeholder: _vm.disabled ? "" : _vm.$t("SeaExport.ShipperId"),
              "auto-uppercase": _vm.autoUppercase,
              disabled: _vm.disabled
            },
            on: {
              change: function($event) {
                return _vm.onChange("shipperCode")
              }
            },
            model: {
              value: _vm.job.shipperCode,
              callback: function($$v) {
                _vm.$set(_vm.job, "shipperCode", $$v)
              },
              expression: "job.shipperCode"
            }
          }),
          _c("cargo-company-select", {
            staticStyle: {
              display: "inline-block",
              width: "145px",
              "flex-grow": "1"
            },
            attrs: {
              disabled: _vm.disabled,
              "method-params": { shipper: true, active: true },
              "default-value": _vm.job.shipperId || ""
            },
            on: { change: _vm.shipperChange }
          })
        ],
        1
      ),
      _vm._l(7, function(i) {
        return _c("cargo-input", {
          key: i,
          staticStyle: { "margin-top": "5px" },
          attrs: {
            "use-read-only": true,
            disabled: _vm.disabled,
            "auto-uppercase": _vm.autoUppercase
          },
          on: {
            change: function($event) {
              return _vm.onChange("shipperLine" + i)
            }
          },
          model: {
            value: _vm.job["shipperLine" + i],
            callback: function($$v) {
              _vm.$set(_vm.job, "shipperLine" + i, $$v)
            },
            expression: "job['shipperLine'+i]"
          }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }